/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const OfficeType = createEnum('OFFICE_TYPE', {
  Franchise: 'FRANCHISE',
  Master: 'MASTER',
  Template: 'TEMPLATE',
  Training: 'TRAINING',
});

export type OfficeType = EnumSet<typeof OfficeType>;
